import * as angular from "angular";
import {IController} from "angular";
import * as _ from "lodash";
import {CommonsDialogService} from "../../../commons/services/commons-dialog.service";
import {ScheduleType} from "../../../schedule/types/schedule.type";
import {ActionReasonEnum} from "../../../action-reasons/enums/action-reason.enum";
import {ActionReasonModel} from "../../../action-reasons/models/action-reason.model";
import {AgentModel} from "../../angular/models/agent.model";
import {AbsenceReasonSettings} from "../../../site-preferences/models/absence-reason-settings.model";
import {IAMPermissionsService} from "../../../../permission/iamPermissions.service";

export class AgentShiftForm implements IController {

  shift: any;
  template?: any;
  branchIds: any;
  serviceAreasIds: any;
  canSelectScheduleType?: boolean;
  agent: AgentModel;
  absenceReasons: AbsenceReasonSettings[];
  onCancel: Function;
  onUpdate: Function;
  onCreate: Function;

  public recurringType: any;
  public extraTimeInMinutes: any;
  public isLocationSettingsActive: boolean;
  public updateSpecificDay: boolean;
  public recurringInterval: number;
  public serviceAreasPriorities: any;
  public recurringDaysOptions: any;
  public scheduleTypeTypes = Object.values(ScheduleType);
  public actionReasonTypes = [ActionReasonEnum.Leave];
  public enabledAbsenceReasons: AbsenceReasonSettings[];
  public scheduleType: typeof ScheduleType = ScheduleType;
  public isLeaveType: boolean;
  public hasFixedLeaveDuration: boolean;

  /* @ngInject */
  constructor(private commonsDialogService: CommonsDialogService, private commonsConstants,
              private resourcesConstants, private moment, private IAMPermissions: IAMPermissionsService) {
    this.serviceAreasPriorities = this.resourcesConstants.serviceAreasPriorities;
    this.recurringDaysOptions = angular.copy(this.commonsConstants.daysCheckboxConfig);
  }

  $onInit() {
    this.enabledAbsenceReasons = this.absenceReasons?.filter(reason => !reason.isArchive);
    this._updateLeaveState();
    const rruleTypes = this.commonsConstants.rruleTypes;
    this.scheduleTypeTypes = [ScheduleType.Shift];

    if (this.IAMPermissions.hasPermission('schedule.availability.create')) {
      this.scheduleTypeTypes.push(ScheduleType.Availability);
    }
    if (this.IAMPermissions.hasPermission('schedule.leave.create')) {
      this.scheduleTypeTypes.push(ScheduleType.Leave);
    }

    if (this.shift) {
      // const rrule = require('rrule');
      // const ruleOptions = rrule.RRule.fromString(_.get(this.shift, 'agentSchedule.schedule.rrule') || '').origOptions;
      // this.recurringType = _.find(rruleTypes, (t) => {
      //   return t.freq === ruleOptions.freq;
      // });

      this.isLocationSettingsActive = !!_.get(this.shift, 'agentSchedule.locationSettings', false);

      if (_.get(this.shift, 'agentSchedule.extraTimeInMillis')) {
        this.shift.agentSchedule.extraTimeInMillis = (this.shift.agentSchedule.extraTimeInMillis / 60000)
      }
    }

  };

  $onChanges(changes: angular.IOnChangesObject) {
    if (changes.shift && !changes.shift.isFirstChange()) {
      this.$onInit();
    }
    if (changes.template) {
      this.recurringType = this.template?.schedule?.freq ? _.find(this.commonsConstants.recurringTypes, (rt) => {
        return rt === this.template.schedule.freq;
      }) : undefined
      this.updateSpecificDay = !!this.recurringType ? false : undefined;
      this.recurringInterval = this.template?.schedule?.interval || 1;
    }
  }

  onRangeChange(from, to) {
    this.shift.agentSchedule.schedule.startTime = from;
    this.shift.agentSchedule.schedule.endTime = to;
    this._applyFixedLeaveDuration();
  }

  onAbsenceReasonChange() {
    this._updateLeaveState();
    this._applyFixedLeaveDuration();
  }

  onRecurringChange(recurringType) {
    this.recurringType = recurringType;
    this.recurringDaysOptions = angular.copy(this.commonsConstants.daysCheckboxConfig);
  }

  onAddSegment(index, event) {

    let offSetToAdd: number = 0
    let durationToAdd: number = 0
    let priorityToAdd = undefined;
    if (index) {
      const prevSegment = _.get(this.shift, `agentSchedule.segments[${index - 1}]`);
      const nextSegment = _.get(this.shift, `agentSchedule.segments[${index}]`);
      offSetToAdd = _.get(prevSegment, 'offsetInMillis', 0) + _.get(prevSegment, 'durationInMillis', 0);
      durationToAdd = nextSegment ? _.get(nextSegment, 'offsetInMillis') - offSetToAdd : _.get(prevSegment, 'durationInMillis', undefined);
      if (durationToAdd === 0) {
        durationToAdd = _.get(prevSegment, 'durationInMillis', undefined)
      }
      priorityToAdd = _.get(prevSegment, `planningAreas[${_.get(prevSegment, 'planningAreas.length') - 1}].priority`, undefined)
    }

    const newSegment = {
      id: this.moment().valueOf(),
      offsetInMillis: offSetToAdd,
      durationInMillis: durationToAdd,
      planningAreas: [
        {
          id: this.moment().valueOf(),
          areaId: undefined,
          priority: priorityToAdd
        }
      ]
    }

    if (!this.shift.agentSchedule.segments) {
      this.shift.agentSchedule.segments = [];
    }

    _.get(this.shift, 'agentSchedule.segments').splice(index, 0, newSegment);
    this.shift.agentSchedule.segments = angular.copy(this.shift.agentSchedule.segments);
  }

  onSegmentFromChange(fromTime, segmentId) {
    const diffOffset = fromTime - this.shift.agentSchedule.schedule.startTime;

    const segmentIdx = _.findIndex(this.shift.agentSchedule.segments, (s: any) => {
      return s.id === segmentId;
    });

    this.shift.agentSchedule.segments[segmentIdx].offsetInMillis = diffOffset;
  }

  onSegmentToChange(toTime, segmentId) {
    const segmentIdx = _.findIndex(this.shift.agentSchedule.segments, (s: any) => {
      return s.id === segmentId;
    });

    this.shift.agentSchedule.segments[segmentIdx].durationInMillis = (toTime - this.shift.agentSchedule.segments[segmentIdx].offsetInMillis - this.shift.agentSchedule.schedule.startTime);
  }

  onAddServiceArea(segmentId, event) {
    const newServiceArea = {
      id: (Date.now()).toString(),
      areaId: undefined,
      priority: undefined
    }

    const segmentIdx = _.findIndex(this.shift.segments, (s: any) => {
      return s.id === segmentId;
    });

    this.shift.agentSchedule.segments[segmentIdx].planningAreas.push(newServiceArea);
  }

  onRemoveServiceArea(segmentId, areaId, event) {
    const segmentIdx = _.findIndex(this.shift.agentSchedule.segments, (s: any) => {
      return s.id === segmentId;
    });

    const areaIdx = _.findIndex(this.shift.agentSchedule.segments[segmentIdx].planningAreas, (a: any) => {
      return a.id === areaId;
    });

    this.shift.agentSchedule.segments[segmentIdx].planningAreas.splice(areaIdx, 1);
  }

  onRemoveSegment(segmentId, $event) {
    const segmentIdx = _.findIndex(this.shift.agentSchedule.segments, (s: any) => {
      return s.id === segmentId;
    });

    this.shift.agentSchedule.segments.splice(segmentIdx, 1);
  }

  onSetSegmentDurationInMillis(durationInMinutes, segmentId) {
    const segmentIdx = _.findIndex(this.shift.agentSchedule.segments, (s: any) => {
      return s.id === segmentId;
    });

    this.shift.agentSchedule.segments[segmentIdx].durationInMillis = (durationInMinutes * 60000);
  }

  onChangeBranches(branchIds) {
    this.shift.agentSchedule.branchIds = branchIds;
  }

  onChangeServiceAreas(serviceAreasIds) {
    this.shift.agentSchedule.serviceAreaIds = serviceAreasIds;
  }

  onToggleLocationSettingsActivation(isActive) {
    this.shift.agentSchedule.locationSettings = isActive ? {} : undefined;
  }

  onLocationSettingsChange(locationSettings) {
    this.shift.agentSchedule.locationSettings = locationSettings;
  }

  onScheduleTypeChange(type: ScheduleType) {
    this.shift.agentSchedule.selectedActionReason = undefined;
    this.shift.agentSchedule.scheduleTypeReason = undefined;

    if (type === ScheduleType.Leave) {
      this.shift.agentSchedule.leaveReason = {
        type: undefined,
        comment: undefined
      }
      this.onRecurringChange(undefined);
      this.shift.agentSchedule.gapInMinutes = undefined;
      this.shift.agentSchedule.extraTimeInMillis = undefined;
    } else {
      _.unset(this.shift.agentSchedule, 'leaveReason');
      this.shift.agentSchedule.absenceReason = undefined;
    }

    this._updateLeaveState();
  }

  onChangeActionReason(actionReason: ActionReasonModel) {
    this.shift.agentSchedule.scheduleTypeReason = actionReason.reason;
  }

  onSubmitUpdate(form) {
    if (form) {
      form.$setSubmitted(true);

      if (form.$valid) {
        const shiftForUpdate = angular.copy(this.shift);
        this._updateShiftBeforeSubmit(shiftForUpdate);

        if (shiftForUpdate.agentSchedule.schedule.freq && !_.isEqual(shiftForUpdate.agentSchedule.schedule.freq, 'DAILY')) {
          // allocationCopy.schedule.byWeekDay = this.allocationCopy.schedule.byWeekDay;
          shiftForUpdate.agentSchedule.schedule.byWeekDay = this.template?.schedule?.byWeekDay;
        } else {
          shiftForUpdate.agentSchedule.schedule.byWeekDay = [];
        }

        this.onUpdate({shift: shiftForUpdate, updateSpecificDay: this.updateSpecificDay});
      }

    }
  }

  // onSubmitCreate(form) {
  //   if (form) {
  //     form.$setSubmitted(true);
  //
  //     if (form.$valid) {
  //       const shiftForUpdate = angular.copy(this.shift);
  //       this._updateShiftBeforeSubmit(shiftForUpdate);
  //
  //       let weekDays = [];
  //       _.forOwn(this.recurringDaysOptions, (value, key) => {
  //         if (!!value.enabled) {
  //           weekDays.push(key);
  //         }
  //       })
  //       if (!weekDays.length) {
  //         weekDays = undefined;
  //       }
  //
  //       this.onCreate({shift: shiftForUpdate, weekDays: weekDays});
  //     }
  //
  //   }
  // }

  onSubmitCreate(form) {
    if (form) {
      form.$setSubmitted(true);

      if (form.$valid) {
        const shiftForUpdate = angular.copy(this.shift);
        this._updateShiftBeforeSubmit(shiftForUpdate);

        let weekDays = [];
        _.forOwn(this.recurringDaysOptions, (value, key) => {
          if (!!value.enabled) {
            weekDays.push(key);
          }
        })
        if (!weekDays.length) {
          weekDays = undefined;
        }

        if (this.recurringType) {
          shiftForUpdate.agentSchedule.schedule.interval = this.recurringType ? this.recurringInterval : undefined;
          shiftForUpdate.agentSchedule.schedule.freq = this.recurringType;
          shiftForUpdate.agentSchedule.schedule.startRecurring = this.template?.schedule?.startRecurring;
          shiftForUpdate.agentSchedule.schedule.endRecurring = this.template?.schedule?.endRecurring;
          shiftForUpdate.agentSchedule.schedule.exceptions = this.template?.schedule?.exceptions;
        }

        this.onCreate({shift: shiftForUpdate, weekDays: weekDays});
      }

    }
  }

  private _updateLeaveState() {
    this.isLeaveType = _.get(this.shift, 'agentSchedule.type') === ScheduleType.Leave;
    this.hasFixedLeaveDuration = this.isLeaveType && !!_.get(this.shift, 'agentSchedule.absenceReason.durationInMinutes');
  }

  private _applyFixedLeaveDuration() {
    const durationInMinutes = _.get(this.shift, 'agentSchedule.absenceReason.durationInMinutes');
    const schedule = _.get(this.shift, 'agentSchedule.schedule');

    if (!this.hasFixedLeaveDuration || !durationInMinutes || !schedule?.startTime) {
      return;
    }

    const startTime = this.moment(schedule.startTime);

    schedule.endTime = this.moment(schedule.endTime || schedule.startTime)
      .startOf('day')
      .set({hour: startTime.hour(), minute: startTime.minute()})
      .add(durationInMinutes, 'minutes')
      .valueOf();
  }

  private _updateShiftBeforeSubmit(shift) {

    if (_.get(this.shift, 'agentSchedule.extraTimeInMillis')) {
      shift.agentSchedule.extraTimeInMillis = (this.shift.agentSchedule.extraTimeInMillis * 60000);
    }

    if (this.recurringType) {
      // const rrule = require('rrule');
      // const roleTest = new rrule.RRule({
      //   freq: _.get(rrule, this.recurringType.value),
      //   dtstart: this.moment(shift.agentSchedule.schedule.startTime).toDate(),
      //   // until: this.moment(this.timeConfig.to.date).toDate(),
      //   interval: 1
      // });
      // shift.agentSchedule.schedule.rrule = this.recurringType ? roleTest.toString() : undefined;
      shift.agentSchedule.schedule.interval = this.recurringType ? 1 : undefined;
      shift.agentSchedule.schedule.freq = this.recurringType;
      shift.agentSchedule.schedule.startRecurring = this.template?.schedule?.startRecurring;
      shift.agentSchedule.schedule.endRecurring = this.template?.schedule?.endRecurring;
      shift.agentSchedule.schedule.exceptions = this.template?.schedule?.exceptions;

      // shift.agentSchedule.schedule.rrule = this.recurringType ? roleTest.toString() : undefined;
      // shift.agentSchedule.schedule.interval = this.recurringType ? 1 : undefined;
      // shift.agentSchedule.schedule.freq = this.recurringType ? this.recurringType.value.substr(6) : undefined;
    }
  }

}

angular
  .module('bringoz.admin.agents')
  .component('agentShiftForm', {
    bindings: {
      shift: '<',
      agent: '<?',
      template: '<?',
      branchIds: '<?',
      serviceAreasIds: '<?',
      canSelectScheduleType: '<?',
      absenceReasons: '<?',
      onCancel: '&',
      onUpdate: '&',
      onCreate: '&'
    },
    template: require('./agent-shift-form.html').default,
    controller: AgentShiftForm
  });
